var x_dialog = function () {},
	x_modals_count = 0;
x_dialog.prototype = {
	modal: {
		show: function (data, url, callback = null) {
			var me = this;

			$.ajax({
				url: url,
				data: data,
				method: 'POST',
				async: false,
				success: function (response) {
					// console.log(data);
					me.render(response);
					xlisteners.init();
					
					if (callback) {
						callback();
					}
				}
			});
		},
		close: function () {
			$('div.modal:last').modal('hide');
		},
		render: function (content) {
			var me = this,
				mod = $(content).appendTo('body'),
				id = mod.attr('id');

			mod.on('hidden.bs.modal', function (e) {
				var last = $('div.modal:last').attr('id');

				if (id == last) {
					mod.remove();
					x_modals_count--;
				}
				//debugger;
				if (x_modals_count > 0) {
					$('div.modal:last').modal('show');
				}
			});

			mod.on('show.bs.modal', function (e) {
				if (x_modals_count > 1) {
					$('div.modal:not(:last)').modal('hide');
				}
			});

			x_modals_count++;

			mod.modal({
				backdrop: 'static', // 'static' | true | false
				keyboard: true,
				show: true,
				remote: false
			});
		}
	},
	notify: {
		show: function (title, text, type, callback) {
			//debugger;
			switch (type) {
				case 'success':
					var obj = {
						//toast: true,
						//position: 'top-center',
						icon: 'success',
						html: text,
						title: title,
						showConfirmButton: false,
						timer: 1000,
						heightAuto: false

					};
					break;
				case 'info':
					var obj = {
						icon: 'info',
						html: text,
						title: title,
						confirmButtonText: 'Supratau'
					};

					break;
				case 'warning':
					var obj = {
						icon: 'warning',
						html: text,
						title: title
						//timer:1000
					};
					break;
				case 'danger':
					//text = ((typeof text == 'object') ? text[0] : text);
					var obj = {
						icon: 'error',
						html: text,
						title: title,
						confirmButtonColor: '#d33',
						confirmButtonText: 'Supratau'
					};
					break;
				case 'loading':
					//text = ((typeof text == 'object') ? text[0] : text);
					var obj = {
						icon: 'info',
						html: text,
						title: title,
						allowOutsideClick: false,
						confirmButtonColor: '#d33',
						confirmButtonText: 'Atšaukti'
					};
					break;
				default:
					var timer = 1000;
					break;
			};

			if (callback === undefined) {
				Swal.fire(obj);
				return;
			}
			loadingbar.stop();
			Swal.fire(obj).then(callback);
		},
		close: function () {
			Swal.close();
		}
	},
	question: {
		show: function (config, callback) {
			var defaults = {
				icon: 'question',
				title: 'Ar tikrai norite?',
				text: 'Šio veiksmo atšaukti negalėsite!',
				showCancelButton: true,
				confirmButtonColor: '#28a745',
				cancelButtonColor: '#757575',
				confirmButtonText: 'Taip',
				cancelButtonText: 'Ne',
				heightAuto: false
			};

			if (config.type) {
				config.icon = config.type;
				delete config.type;
			}

			$.extend(defaults, config);

			Swal.fire(defaults).then(function (answer) {
				// callback((answer.dismiss == 'cancel') ? false : true);
				// answer turi kelis `dismiss` tipus: `cancel`, `overlay` - mums svarbu tik, kai patvirtino
				callback((answer.value ? true : false), answer);
			});
		}
	},
	close: function () {

	},
	tooltip: {
		show: function (element, tooltip, style) {
			element.tooltipster({
				content: tooltip || element.data('tooltip') || element.attr('title'),
				contentAsHTML: true,
				interactive: true
			});
		},
		remote: function (element, url, data) {
			if (element.hasClass('tooltipstered')) {
				return;
			}

			xcrud.load(url, data, function (html) {
				element.tooltipster({
					content: html,
					contentAsHTML: true,
					interactive: true
				}).tooltipster('open');
			});
		}
	}
}

var xdialog = new x_dialog();